import {Component, Input, OnInit} from '@angular/core';
import {NzModalService, NzModalSubject} from "ng-zorro-antd";
import {GlobalService} from "../../services/global.service";
import {HttpCommonService} from "../../services/http-common.service";
import {subscribeOn} from "rxjs/operators/subscribeOn";
import {EnterpMonitor} from "../../services/enterp-monitor.service";
import {Router} from "@angular/router";
import {Company, EnterpIntroductionServiceService} from "../../services/enterp-introduction-service.service";
import {EnterCertifitionListService} from "../../services/enter-certification-list.service";

@Component({
  selector: 'app-permission-comparison',
  templateUrl: './permission-comparison.component.html',
  styleUrls: ['./permission-comparison.component.css']
})
export class PermissionComparisonComponent implements OnInit {
  hover = 0;
  userType: any;
  @Input() showRegisterBtn = '1';
  @Input() companyId: string;
  isCertific: string;
  companyInfo: Company;//基础信息
  isUnderEntry = '0';
  order: any;
  newEnter: any = {};
  bankAccountNo: any = null; //企业银行账号
  bankAccountName: any = null; //企业银行帐户名
  bankDeposit: any = null;//开户行
  cityId: any = null; //所属市id
  cityName: any = null; //所属市
  provinceId: any = null; //所属省id
  provinceName: any = null;//所属省
  orderNo: any = null;
  xhCode: any = null;
  isCompanyLoaded = false;//企业信息是否加载完成

  _isSpinning = true;

  personUserAuthority = {
    "company:reportDownload": null,
    "company:checkMap": null,
    "company:reportExpirationDate": null,
    "company:monitorNumber": null,
    "company:monitorRange": null,
    "company:showNumber": null,
    "company:download": null,
    "company:searchNumber": null,
    "company:checkCredit": null,
  };
  companyUserAuthority = {
    "company:reportDownload": null,
    "company:checkMap": null,
    "company:reportExpirationDate": null,
    "company:monitorNumber": null,
    "company:monitorRange": null,
    "company:showNumber": null,
    "company:download": null,
    "company:searchNumber": null,
    "company:checkCredit": null,
  };
  mechanismUserAuthority = {
    "company:reportDownload": null,
    "company:checkCredit": null,
    "company:checkMap": null,
    "company:reportExpirationDate": null,
    "company:checkMonitor": null,
    "company:monitorNumber": null,
    "company:monitorRange": null,
    "company:checkSupervise": null,
    "company:showNumber": null,
    "company:searchNumber": null,
    "company:checkRating": null,
  };

  constructor(private subject: NzModalSubject,
              private globalService: GlobalService,
              private router: Router,
              private showConfirm: NzModalService,
              private ecls: EnterCertifitionListService,
              private companyService: EnterpIntroductionServiceService,
              private http: HttpCommonService) {
    this.userType = this.globalService.getUserInfo("_userType");
  }

  ngOnInit() {
    //console.log(this.companyId);
    this.getAuthority();
    this.queryEnter();
    //企业是否入驻
    this.http.get("/user/center/xhsRest/certifi/isHasCertific", {companyId: this.companyId})
      .subscribe(result => {
        this.isCertific = result.data;
      });
    this.http.get('/enterprise/detail/xhsRest/baseMsg/getCompanyInfo', {companyId: this.companyId})
      .subscribe(data => {
        if (data.stateCode == '60111') {
          this.companyInfo = new Company(data.data.returnData[0], false);
          this.isCompanyLoaded = true;
        }
      });
    if (this.userType == "person") {
      //企业是否在入驻流程中
      this.ecls.isUnderEntry(this.companyId)
        .subscribe(result => {
          if (result.stateCode == '1') {
            this.isUnderEntry = result.data;
          }
        });
    }
    //获取订单信息
    this.http.get("/user/center/xhsRest/entry/selectOrderNo", {companyId: this.companyId}).subscribe(data => {
      this.order = data.data;
    });
  }


  // 动态获取权限
  getAuthority() {
    this.http.get('/user/center/xhsRest/getRightsInfo').subscribe(data => {

      console.log(data.data);

      let thiss = this;
      if (data) {
        thiss.personUserAuthority = data.data.personUser;
        thiss.companyUserAuthority = data.data.companyUser;
        thiss.mechanismUserAuthority = data.data.mechanismUser;

        if (data.data.personUser['company:monitorRange'] != null) {
          let numArr1 = data.data.personUser['company:monitorRange'];
          if (numArr1.length > 2) {
            $(".line1 p.special").addClass('specialCss');
          }
          thiss.personUserAuthority['company:monitorRange'] = thiss.setNumValue(numArr1);
        }
        if (data.data.companyUser['company:monitorRange'] != null) {
          let numArr2 = data.data.companyUser['company:monitorRange'];
          if (numArr2.length > 2) {
            $(".line2 p.special").addClass('specialCss');
          }
          thiss.companyUserAuthority['company:monitorRange'] = thiss.setNumValue(numArr2);
        }

        if (data.data.mechanismUser['company:monitorRange'] != null) {
          let numArr3 = data.data.mechanismUser['company:monitorRange'];
          if (numArr3.length > 2) {
            $(".line3 p.special").addClass('specialCss');
          }
          thiss.mechanismUserAuthority['company:monitorRange'] = this.setNumValue(numArr3);
        }

        setTimeout(function () {
          $(".line p:empty").html('<img src="../../../assets/images/dbico1.png" alt="暂不支持"/>');
        }, 100);

        thiss._isSpinning = false;
      }

    });
  }

  // 处理后台返回的key值
  setNumValue(str1) {
    // let str = str1;
    str1 = str1.replace("1", "正面信息");
    str1 = str1.replace("2", "负面信息");
    str1 = str1.replace("3", "经营状况");
    str1 = str1.replace("4", "业务变更");
    str1 = str1.replace("5", "关联风险");
    return str1;
  }

  registerEnterp() {
    if(!this.isCompanyLoaded){
      return;
    }
    this.closeAlert();
    let thiss = this;
    if (this.userType == 'person') {
      if (this.isCertific == '1' || this.isCertific == '2') {//未认证
        // 是否已实名认证
        this.http.get("/user/center/xhsRest/isRealAuthent")
          .subscribe(result => {
            if (result.data == "0") {//未认证

              this.showConfirm.confirm({
                title: '',
                content: '您尚未完成个人实名认证，暂时不能进行企业入驻申请，立即前往完成实名认证？',
                okText: '前往',
                onOk() {
                  thiss.router.navigate(['MemberCenterParent/PersonInfoParent/centerRealName'],
                    {queryParams: {companyId: thiss.companyId, type: '3'}});
                },
                onCancel() {
                }
              });
            } else if (result.data == "1") {
              thiss.showConfirm.info({
                content: '您尚未通过个人实名认证审核，请耐心等待',
                okText: '确定'
              });
            } else {//已认证
              // 统一社会信用代码存在
              if (thiss.companyInfo && thiss.companyInfo.creditCode) {
                if (thiss.isUnderEntry == '1') {
                  if ((thiss.order.payStatus == "0" || thiss.order.payStatus == "-1") && thiss.order.orderStatus == "0") {
                    thiss.showConfirm.error(
                      {
                        content: "您已经提交该企业入驻申请,完成支付后才可进入审核环节,是否立即前往支付？",
                        okText: '立即支付',
                        cancelText: '取消',
                        onOk() {
                          thiss.router.navigate(["/pay"],
                            {
                              queryParams: {
                                orderNo: thiss.order.orderNo,
                                orderType: thiss.order.orderType,
                                orderName: "企业入驻审核费"
                              }
                            });
                        },
                        onCancel() {
                        }
                      });
                  } else if (thiss.order.payStatus == "0" && thiss.order.orderStatus == "2") {
                    if (this.newEnter == null || this.newEnter == undefined) {
                      thiss.router.navigate(['registerEnterp'], {queryParams: {companyId: thiss.companyId, type: '2'}});
                    } else {
                      thiss.router.navigate(['registerEnterp'], {
                        queryParams: {
                          companyId: thiss.companyId,
                          orderNo: this.orderNo,
                          bankDeposit: this.bankDeposit,
                          bankAccountNo: this.bankAccountNo,
                          cityId: this.cityId,
                          cityName: this.cityName,
                          provinceId: this.provinceId,
                          provinceName: this.provinceName,
                          bankAccountName: this.bankAccountName, type: '2'
                        }
                      });
                    }
                  } else {
                    thiss.showConfirm.error({content: '您已经提交该企业入驻申请，可进入个人中心-入驻企业查看当前进度', width: '350px', okText: '确认'});
                  }
                } else {
                  if (this.newEnter == null || this.newEnter == undefined) {
                    thiss.router.navigate(['registerEnterp'], {queryParams: {companyId: thiss.companyId, type: '2'}});
                  } else {
                    thiss.router.navigate(['registerEnterp'], {
                      queryParams: {
                        companyId: thiss.companyId,
                        orderNo: this.orderNo,
                        bankDeposit: this.bankDeposit,
                        bankAccountNo: this.bankAccountNo,
                        cityId: this.cityId,
                        cityName: this.cityName,
                        provinceId: this.provinceId,
                        provinceName: this.provinceName,
                        bankAccountName: this.bankAccountName, type: '2'
                      }
                    });
                  }

                }
              } else {
                thiss.showConfirm.error({content: '该企业未进行三证合一,尚无统一社会信用码,请到工商部门换发新版营业执照', width: '350px', okText: '确认'});
              }
            }
          });
        //认证中或已认证
      } else {
        this.router.navigate(['/registerEnterp'], {queryParams: {type: 1}});
      }
    }
  }

  queryEnter() {
    this.http.post("/user/center/xhsRest/certifi/queryEnter", {
      companyId: this.companyId
    }).subscribe(data => {
      if (data.data != null) {
        this.newEnter = data.data;
        this.provinceId = data.data.provinceId;
        this.provinceName = data.data.provinceName;
        this.cityId = data.data.cityId;
        this.cityName = data.data.cityName;
        this.bankAccountNo = data.data.bankAccountNo;
        this.bankAccountName = data.data.bankAccountName;
        this.bankDeposit = data.data.bankDeposit;
        this.orderNo = data.data.orderNo;
      }
    });
  }


  closeAlert() {
    this.subject.destroy('onOk');
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/permission-comparison/permission-comparison.component.ts